import { trackEvent } from "@amplio-common/analytics";
import {
  LOAD_USERS,
  LOAD_USERSV2,
  LOAD_STUDENTS,
  LOAD_THERAPISTS,
  SELECT_THERAPIST,
  SELECT_STUDENT,
  LOAD_STUDENT_AGREEMENTS,
  SAVE_STUDENT_AGREEMENTS,
  UPDATE_STUDENT,
  UPDATE_STUDENT_LANGUAGE,
  SELECT_USER,
  LOAD_USER_DETAILS,
  LOAD_STUDENT_FILES,
  UPLOAD_STUDENT_FILES,
  LOAD_STUDENT_FILE,
} from "./actions";

const initialState = {
  isLoading: false,
  isFullListLoaded: false,
  isLoadingV2: false,
  files: {
    isLoading: false,
    errorMsg: "",
  },
  isLoadingDetails: false,
  isLoadingStudentAgreements: false,
  selectedTherapist: {},
  studentFiles: [],
  usersList: [],
  pageSize: 20,
  usersCount: 0,
};

const users = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER_DETAILS.REQUEST:
      return {
        ...state,
        isLoadingDetails: true,
      };
    case LOAD_USER_DETAILS.SUCCESS:
      return {
        ...state,
        isLoadingDetails: false,
      };
    case LOAD_USER_DETAILS.FAILURE:
      return {
        ...state,
        isLoadingDetails: false,
      };

    case LOAD_USERS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isFullListLoaded: true,
      };
    case LOAD_USERS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFullListLoaded: false,
      };
    case LOAD_USERS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isFullListLoaded: false,
      };
    case LOAD_USERSV2.REQUEST:
      return {
        ...state,
        isLoadingV2: true,
      };
    case LOAD_USERSV2.SUCCESS: {
      const { results: usersList, count: usersCount, isEdited } = action.payload.response;
      if (isEdited && usersList && usersList.length) {
        const updateUserInd = state.usersList.findIndex(i => i.id === usersList[0].id);
        state.usersList.splice(updateUserInd, 1, usersList[0]);
        return {
          ...state,
          isLoadingV2: false,
        };
      }
      return {
        ...state,
        usersList,
        usersCount,
        isLoadingV2: false,
      };
    }
    case LOAD_USERSV2.FAILURE:
      return {
        ...state,
        isLoadingV2: false,
      };
    case LOAD_STUDENTS.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_STUDENTS.SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case LOAD_STUDENTS.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case LOAD_THERAPISTS.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_THERAPISTS.SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case LOAD_THERAPISTS.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case SELECT_USER:
      return {
        ...state,
        selectedUser: action.payload.user,
      };

    case SELECT_THERAPIST:
      return {
        ...state,
        selectedTherapist: action.payload.therapist,
      };
    case SELECT_STUDENT:
      return {
        ...state,
        selectedStudent: action.payload.student,
      };
    // LOAD STUDENT AGREEMENTS
    case LOAD_STUDENT_AGREEMENTS.REQUEST:
      return {
        ...state,
        isLoadingStudentAgreements: true,
      };
    case LOAD_STUDENT_AGREEMENTS.SUCCESS:
      return {
        ...state,
        isLoadingStudentAgreements: false,
      };
    case LOAD_STUDENT_AGREEMENTS.FAILURE:
      return {
        ...state,
        isLoadingStudentAgreements: false,
      };
    // UPDATE STUDENT AGREEMENTS
    case SAVE_STUDENT_AGREEMENTS.REQUEST:
      trackEvent("agreements_saved", { more_information: action.payload.notMandatoryAgree });
      return {
        ...state,
        isLoadingStudentAgreements: true,
      };
    case SAVE_STUDENT_AGREEMENTS.SUCCESS:
      return {
        ...state,
        isLoadingStudentAgreements: false,
      };
    case SAVE_STUDENT_AGREEMENTS.FAILURE:
      return {
        ...state,
        isLoadingStudentAgreements: false,
      };
    // UPDATE STUDENT
    case UPDATE_STUDENT.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_STUDENT.SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case UPDATE_STUDENT.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    // UPDATE STUDENT LANGUAGE
    case UPDATE_STUDENT_LANGUAGE.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_STUDENT_LANGUAGE.SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case UPDATE_STUDENT_LANGUAGE.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    // LOAD FILES
    case LOAD_STUDENT_FILES.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_STUDENT_FILES.SUCCESS:
      return {
        ...state,
        studentFiles: action.payload.response,
        isLoading: false,
      };
    case LOAD_STUDENT_FILES.FAILURE:
      return {
        ...state,
        studentFiles: [],
        isLoading: false,
      };
    // UPLOAD FILES
    case UPLOAD_STUDENT_FILES.REQUEST:
      return {
        ...state,
        isLoading: true,
        files: {
          isLoading: true,
          errorMsg: "",
        },
      };
    case UPLOAD_STUDENT_FILES.SUCCESS:
      return {
        ...state,
        isLoading: false,
        files: {
          isLoading: false,
          errorMsg: "",
        },
      };
    case UPLOAD_STUDENT_FILES.FAILURE:
      return {
        ...state,
        isLoading: false,
        files: {
          isLoading: false,
          errorMsg: action.payload.error.toString(),
        },
      };

    // LOAD FILE
    case LOAD_STUDENT_FILE.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_STUDENT_FILE.SUCCESS:
      return {
        ...state,
        studentFile: action.payload.response,
        isLoading: false,
      };
    case LOAD_STUDENT_FILE.FAILURE:
      return {
        ...state,
        studentFile: false,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default users;
